import { createContext, ReactNode, useContext } from "react";
import { DndSortZoneProps } from "../DndSortZone";

export type PreviewRendererParams = {
  valid: boolean; // Indicates if the item being dragged is valid for the current drop target
};

export type PreviewRenderer = (params: PreviewRendererParams) => ReactNode;

export type DndSortZoneContextValue =
  | (Omit<DndSortZoneProps, "sortedIds" | "orientation" | "gap"> & {
      sortable: boolean;
      sortedIds?: (string | number)[];
      orientation?: "horizontal" | "vertical";
    })
  | null;

const DndSortZoneContext = createContext(null as DndSortZoneContextValue);

/**
 * Tells items information about the zone they are contained within.
 * @param props - The props for the DndSortZoneContextProvider component
 * @param props.children - The child components to be rendered inside the context provider
 * @param props.id - The unique identifier for the drop zone
 * @param props.sortable - Whether the drop zone is sortable
 * @param props.sortedIds - The sorted IDs of the items in the drop zone
 * @param props.orientation - The orientation of the drop zone
 
 * @returns
 */
export default function DndSortZoneContextProvider(
  props: DndSortZoneContextValue,
) {
  return (
    <DndSortZoneContext.Provider value={props}>
      {props?.children}
    </DndSortZoneContext.Provider>
  );
}

export const useDndSortZoneContext = () => {
  return useContext(DndSortZoneContext);
};
